module.exports = __webpack_public_path__ + "dc69060b95acf5b9150a5b3925264ffe.pdf";